'use strict';

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=BasicDependencies.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/BasicDependencies.js
// module id = 1273
// module chunks = 5